export default __webpack_public_path__ + "static/media/myReads.2847bbee.gif";